import React, { useState } from 'react';
import { postsAPI } from '../services/api';
import { Wand2, Save, FileText, Globe } from 'lucide-react';
import '../styles/refinador.css';

const Refinador = () => {
  const [originalText, setOriginalText] = useState('');
  const [refinedText, setRefinedText] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [title, setTitle] = useState('');

  const handleRefine = async () => {
    if (!originalText.trim()) {
      setError('Por favor, insira um texto para refinar.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');
    setRefinedText('');

    try {
      const response = await postsAPI.refineText({ text: originalText });
      setRefinedText(response.data?.data || response.data || '');
      setSuccess('Texto refinado com sucesso!');
    } catch (error) {
      setError(error.response?.data?.error || 'Erro ao refinar texto.');
    } finally {
      setLoading(false);
    }
  };

  const savePost = async (sendToWordPress = false, publish = false) => {
    if (!refinedText.trim()) {
      setError('Nenhum texto refinado para salvar.');
      return;
    }

    if (!title.trim()) {
      setError('Por favor, informe um título para o post.');
      return;
    }

    setSaving(true);
    setError('');
    setSuccess('');

    try {
      // Gerar excerpt simples a partir do HTML refinado
      const plainText = refinedText
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      const excerpt = plainText.substring(0, 300);

      const postData = {
        title: title.trim(),
        content: refinedText,
        excerpt,
        status: 'draft',
        sendToWordPress: sendToWordPress,
        publishToWordPress: publish
      };

      const createResp = await postsAPI.createPost(postData);
      const createdId = createResp?.data?.id || createResp?.data?.data?.id;

      if (sendToWordPress && createdId) {
        const payload = { excerpt };
        if (publish) {
          await postsAPI.publishToWordPress(createdId, payload);
          setSuccess('Texto salvo e enviado para o WordPress como publicado com sucesso!');
        } else {
          await postsAPI.sendDraftToWordPress(createdId, payload);
          setSuccess('Texto salvo e enviado para o WordPress como rascunho com sucesso!');
        }
      } else {
        setSuccess('Texto salvo com sucesso!');
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Erro ao salvar texto.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="refinador-container">
      <div className="refinador-header">
        <h1><Wand2 size={24} /> Refinador de Textos</h1>
        <p>Insira seu texto e deixe a IA formatá-lo com HTML para seu blog.</p>
      </div>

      <div className="refinador-content">
        <div className="input-section">
          <h3>Texto Original</h3>
          <textarea
            value={originalText}
            onChange={(e) => setOriginalText(e.target.value)}
            placeholder="Digite ou cole o texto que deseja refinar..."
            rows={10}
            className="text-input"
          />
          <button 
            onClick={handleRefine} 
            disabled={loading}
            className="refine-btn"
          >
            {loading ? 'Refinando...' : 'Refinar Texto'}
          </button>
        </div>

        {refinedText && (
          <div className="output-section">
            <h3>Texto Refinado (com HTML)</h3>
            <div className="title-input-row">
              <label htmlFor="refined-title">Título do Post</label>
              <input
                id="refined-title"
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Digite o título do post"
                className="text-input"
                style={{marginBottom: '15px', marginTop: '15px'}}
              />
            </div>
            <div className="text-output">
              <textarea
                value={refinedText}
                onChange={(e) => setRefinedText(e.target.value)}
                rows={10}
                className="text-input"
                readOnly={false}
              />
            </div>
            
            <div className="action-buttons">
              <button 
                onClick={() => savePost(false)}
                disabled={saving}
                className="save-btn"
              >
                <Save size={16} /> Salvar Post
              </button>
              
              <button 
                onClick={() => savePost(true, false)}
                disabled={saving}
                className="draft-btn"
              >
                <FileText size={16} /> Enviar como Rascunho
              </button>
              
              <button 
                onClick={() => savePost(true, true)}
                disabled={saving}
                className="publish-btn"
              >
                <Globe size={16} /> Enviar como Publicado
              </button>
            </div>
          </div>
        )}
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {success && (
        <div className="success-message">
          {success}
        </div>
      )}
    </div>
  );
};

export default Refinador;